<!-- <app-nav></app-nav>
<div [ngSwitch]="routeVal">
    <div *ngSwitchDefault>
        <app-doc-upload-list></app-doc-upload-list>
    </div>
    <div *ngSwitchCase="'1'"  >
        <app-edit-doc-upload-list [childMessage]="associateData"></app-edit-doc-upload-list>
    </div>
  
</div>

<app-footer></app-footer> -->


<app-common-menu></app-common-menu>
